import { SelectOption } from "../../../types";
import { FormSchema } from "../FormBuilder/FormBuilder.types";
import { getFirstStepData, getThirdStepData } from "./ReviewForm.api";
import { BANKI_RU_PLATFORM_ID } from "./ReviewForm.constants";
import { FieldData } from "./ReviewForm.types";

export const isBankiRuPlatform = (app?: { value?: string | number }) =>
  app?.value === BANKI_RU_PLATFORM_ID;

export const populateOptions = (form: FormSchema, options: SelectOption[], name: string): FormSchema => {
    const elementsWithOptions = form.elements.map((element) => {
        if (element.name === name) {
            return { ...element, options: options };
        }

        return element;
    });

    return { ...form, elements: elementsWithOptions }
}

export const setFieldVisible = (form: FormSchema, name: string, visible: boolean): FormSchema => ({
    ...form,
    elements: form.elements.map((element) => {
        if (element.name === name) {
            return { ...element, visible: visible }
        }

        return element;
    })
})

export const getFormData = async (activeStepIndex: number): Promise<FieldData[]> => {
    if (activeStepIndex === 0) {
        return getFirstStepData();
    }

    return getThirdStepData();
}